<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        xAxis: {},
        yAxis: {},
        series: [
          {
            symbolSize: 20,
            data: [
              [10, 10],
              [20, 30],
              [30, 20],
              [40, 40]
            ],
            type: "scatter"
          }
        ]
      }
    };
  }
};
</script>
